export default __webpack_public_path__ + "static/media/ButtonNormal.min.28d97c79.png";